function revealHeroSliderSection(section) {
  if (!section || section.classList.contains('hero-slider-section--ready')) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    section.classList.add('hero-slider-section--ready');
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      section.classList.add('hero-slider-section--ready');
    });
  });
}

window.revealHeroSliderSection = revealHeroSliderSection;

function initHeroSliderSectionReveal(scope = document) {
  scope.querySelectorAll('.hero-slider-section--reveal:not(.hero-slider-section--ready)').forEach((section) => {
    const swiperEl = section.querySelector('.main-hero-swiper');
    if (swiperEl?.classList.contains('swiper-initialized')) {
      revealHeroSliderSection(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeroSliderSectionReveal());
} else {
  initHeroSliderSectionReveal();
}

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  document.querySelectorAll('.hero-slider-section--reveal').forEach((section) => {
    section.classList.add('hero-slider-section--ready');
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.hero-slider-section--reveal');
    if (section) {
      section.classList.remove('hero-slider-section--ready');
      revealHeroSliderSection(section);
    }
  });
}
